import { render, staticRenderFns } from "./exception-type-save.vue?vue&type=template&id=367a5c79"
import script from "./exception-type-save.vue?vue&type=script&lang=js"
export * from "./exception-type-save.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports